import{jsx as t}from"react/jsx-runtime";import o from"react-lottie";import r from"styled-components";import{COLORS as e}from"../../constants/Theme.js";import*as i from"./lotties/black.json.js";import*as n from"./lotties/brand.json.js";import*as s from"./lotties/red.json.js";import*as a from"./lotties/white.json.js";import{SizeMap as m}from"./themes.js";const l={[e.stroke.brand]:n,[e.content.primary]:i,[e.content.primaryInverse]:a,[e.content.negative]:s},d=r=>{let{size:i,color:n,className:s}=r;const a={loop:!0,autoplay:!0,animationData:l[null!=n?n:e.stroke.brand],rendererSettings:{preserveAspectRatio:"xMidYMid slice"}};return t("div",Object.assign({className:`spinner-container ${s}`},{children:t(o,{options:a,width:m[i],isStopped:!1,isPaused:!1})}))};d.displayName="Spinner";const p=r.div`
	width: ${t=>t.width};
	height: ${t=>t.height};
	border: 5px solid ${t=>{var o;return null!==(o=t.backgroundColor)&&void 0!==o?o:"transparent"}};
	border-bottom-color: ${t=>{var o;return null!==(o=t.color)&&void 0!==o?o:e.stroke.brand}};
	border-radius: 50%;
	display: inline-block;
	animation: rotation 1s linear infinite;

	@keyframes rotation {
		0% {
			transform: rotate(0deg);
		}
		100% {
			transform: rotate(360deg);
		}
	}
`;export{p as PureSpinner,d as Spinner};
